import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Create,
} from "adminApi/ItemsUnitApi/ItemsUnit";
import fields from "../json/ItemsUnitFields.json";
import { validateForm } from "utils/validation";
import { ItemsUnitRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddItemsUnitForm from "./Componates/AddItemsUnitForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddItemsUnit = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(initialValues, ItemsUnitRules);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, ItemsUnitRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Item Unit created successfully"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddItemsUnitForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Create Item Unit Type"
      />
    </>
  );
};

export default AddItemsUnit;
